import { get, post } from '@/utils/https'
import {
  buildBillingDraftBody,
  buildBillingDraftQueryParams,
  type BillingDraftCompany,
} from '@/lib/e-invoicing/billingDraftCompany'

export async function fetchFreelancerBillingProfile(
  teamId?: string | null,
  draftCompany?: BillingDraftCompany | null,
) {
  const params = {
    ...(teamId ? { teamId } : {}),
    ...buildBillingDraftQueryParams(draftCompany),
  }
  const response = await get(
    '/api/app/v1/freelancers/billing/profile',
    Object.keys(params).length > 0 ? params : undefined,
  )
  return response?.data
}

export async function runFreelancerPaCheck(draftCompany?: BillingDraftCompany | null) {
  const body = buildBillingDraftBody(draftCompany)
  const response = await post(
    '/api/app/v1/freelancers/billing/pa-check',
    body ?? undefined,
  )
  return response?.data
}

export async function resetFreelancerPaCheck() {
  const response = await post('/api/app/v1/freelancers/billing/pa-reset')
  return response?.data
}

export async function initiateBillingMandateSignature(draftCompany?: BillingDraftCompany | null) {
  const body = buildBillingDraftBody(draftCompany)
  const response = await post(
    '/api/app/v1/freelancers/billing/mandate/initiate',
    body ?? undefined,
  )
  return response?.data
}

export async function expireBillingMandate() {
  const response = await post('/api/app/v1/freelancers/billing/mandate/expire')
  return response?.data
}
